// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2376":"f88ac20d","3179":"f88ac20d","4544":"f88ac20d","7085":"f88ac20d","7888":"f88ac20d","8085":"f88ac20d","8763":"f88ac20d"}[chunkId] + ".chunk.css";
};